import { Action } from '@ngrx/store';
import { UserGuide } from '@model';

export enum UserGuidesActionTypes {
  UserGuidesLoad = '[UserUserGuides] Load userguide data',
  UserGuidesLoadSuccess = '[UserUserGuides] Load userguide success',
  UserGuidesLoadFail = '[UserUserGuides] Load userguide fail',

  GuideSetAsRead = '[UserUserGuides] Set guide as read data',
  GuideSetAsReadSuccess = '[UserUserGuides] Set guide as read success',
  GuideSetAsReadFail = '[UserUserGuides] Set guide as read fail'
}

export class UserGuidesLoad implements Action {
  readonly type = UserGuidesActionTypes.UserGuidesLoad;
  constructor() {}
}

export class UserGuidesLoadSuccess implements Action {
  readonly type = UserGuidesActionTypes.UserGuidesLoadSuccess;
  constructor(public payload: UserGuide[]) {}
}

export class UserGuidesLoadFail implements Action {
  readonly type = UserGuidesActionTypes.UserGuidesLoadFail;
  constructor(public payload: any) {}
}

export class GuideSetAsRead implements Action {
  readonly type = UserGuidesActionTypes.GuideSetAsRead;
  constructor(public payload: number) {}
}

export class GuideSetAsReadSuccess implements Action {
  readonly type = UserGuidesActionTypes.GuideSetAsReadSuccess;
  constructor(public payload: UserGuide) {}
}

export class GuideSetAsReadFail implements Action {
  readonly type = UserGuidesActionTypes.GuideSetAsReadFail;
  constructor(public payload: any) {}
}

export type UserGuidesActions =
  | UserGuidesLoad
  | UserGuidesLoadSuccess
  | UserGuidesLoadFail
  | GuideSetAsRead
  | GuideSetAsReadSuccess
  | GuideSetAsReadFail;
